import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import CountriesComponent from './js/countries.component';

ComponentsFactory.getInstance().define('countries', CountriesComponent);
